{
  "$comment": "Raw HTML embed allowlist (Dawn, 2026-10-20). The ONE list: read by rawHtmlEmbeds.ts (live sanitizer, Studio preview + note, RawHtmlBlock) and by apps/tenant-sites next.config.mjs (CSP). Origins are https, lowercase, default port. paths: exact path or path + '/...'; no paths = any path on that origin.",
  "frames": [
    { "origin": "https://www.youtube.com" },
    { "origin": "https://www.youtube-nocookie.com" },
    { "origin": "https://player.vimeo.com" },
    { "origin": "https://www.google.com", "paths": ["/maps/embed"] },
    { "origin": "https://calendly.com" },
    { "origin": "https://form.typeform.com" },
    { "origin": "https://my.matterport.com" }
  ],
  "scripts": [
    { "origin": "https://assets.calendly.com" },
    { "origin": "https://embed.typeform.com" }
  ]
}
